import serverApi from "../../utils/serverApi"

const dashboardService = {
  getStatisticalInfo: () => serverApi({ uri: "admin/dashboard/get-statistical-info", method: "GET" }),
}

export default dashboardService
